import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetch_trainer_details, save_trainer_details } from './api';
import type { TrainerDetailsRequest } from './types';

const KEY = ['module-details', 'trainer'] as const;

export function use_save_trainer_details() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: TrainerDetailsRequest) => save_trainer_details(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['onboarding', 'draft'] });
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function use_trainer_details(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: KEY,
    queryFn: fetch_trainer_details,
    staleTime: 0,
    retry: 0,
    enabled: options?.enabled ?? true,
  });
}
